export var isMobile = (function () {
    if (typeof navigator === 'undefined' ||
        typeof navigator.userAgent !== 'string') {
        return false;
    }
    return /Mobile/.test(navigator.userAgent);
})();
//# sourceMappingURL=isMobile.js.map